import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ConfigProvider } from "antd";
import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { LayoutContextProvider } from "./context/LayoutContext";
import { LoadingContextProvider } from "./context/LoadingContext";
import { UserAgentContextProvider } from "./context/UserAgentContext";
import reportWebVitals from "./reportWebVitals";
import "./style";

const defaultTheme = require(`./theme/defaultTheme.json`);
const finalTheme = { ...defaultTheme };

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      //ms time until subsequent request will be triggered again
      staleTime: 3000,
      //when request failed, by default will retry 3x with exponential backoff delay before returning error
      //turn off this option on dev mode to make quicker dev experience
      retry: false,
      //option to refetch data when windows on focus to keep showing latest data to user
      //also turn this off on dev env for simplicity
      refetchOnWindowFocus: false,
    },
  },
});

const container = document.getElementById("root");

if (container) {
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <ConfigProvider
          wave={{ disabled: true }}
          theme={{
            token: {
              ...finalTheme,
              fontFamily: process.env.REACT_APP_FONT_FAMILY,
            },
            components: {
              Popconfirm: { zIndexPopup: 2000 },
            },
          }}
          button={{ className: "custom-button" }}
          input={{ className: "custom-input" }}
          inputNumber={{ className: "custom-number-input" }}
          textArea={{ className: "custom-text-area" }}
          form={{ className: "custom-form" }}
          datePicker={{ className: "custom-date-picker" }}
          rangePicker={{ className: "custom-range-picker" }}
          select={{ className: "custom-select" }}
          avatar={{ className: "custom-avatar" }}
          card={{ className: "custom-card" }}
          collapse={{ className: "custom-collapse" }}
          dropdown={{ className: "custom-dropdown" }}
          steps={{ className: "custom-steps" }}
          divider={{ className: "custom-divider" }}
          tabs={{ className: "custom-tabs" }}
          descriptions={{ className: "custom-descriptions" }}
          statistic={{ className: "custom-statistic" }}
        >
          <LayoutContextProvider>
            <LoadingContextProvider>
              <UserAgentContextProvider>
                <BrowserRouter>
                  <App />
                </BrowserRouter>
              </UserAgentContextProvider>
            </LoadingContextProvider>
          </LayoutContextProvider>
        </ConfigProvider>
      </QueryClientProvider>
    </React.StrictMode>,
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
